import Dependencies from '../utilities/dependencies';

export default class Gallery {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.gallery-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [
		Dependencies.libraries.jQuery,
		[Dependencies.libraries.luminous]
	];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		if(this.#holderElement.querySelectorAll('.js-gallery-link')){
			new LuminousGallery(this.#holderElement.querySelectorAll(".js-gallery-link"));
		}
	}

}
